// NOTE this file is auto-generated by config/@lvflanders/generate-lit-bar-dependencies.js
// Any manual edits will be overwritten.
import * as litNamespaceRoot from "lit";
import * as litNamespaceAsyncDirective from "lit/async-directive.js";
import * as litNamespaceDecorators from "lit/decorators.js";
import * as litNamespaceDecoratorsCustomElement from "lit/decorators/custom-element.js";
import * as litNamespaceDecoratorsEventOptions from "lit/decorators/event-options.js";
import * as litNamespaceDecoratorsProperty from "lit/decorators/property.js";
import * as litNamespaceDecoratorsQueryAll from "lit/decorators/query-all.js";
import * as litNamespaceDecoratorsQueryAssignedElements from "lit/decorators/query-assigned-elements.js";
import * as litNamespaceDecoratorsQueryAssignedNodes from "lit/decorators/query-assigned-nodes.js";
import * as litNamespaceDecoratorsQueryAsync from "lit/decorators/query-async.js";
import * as litNamespaceDecoratorsQuery from "lit/decorators/query.js";
import * as litNamespaceDecoratorsState from "lit/decorators/state.js";
import * as litNamespaceDirectiveHelpers from "lit/directive-helpers.js";
import * as litNamespaceDirective from "lit/directive.js";
import * as litNamespaceDirectivesAsyncAppend from "lit/directives/async-append.js";
import * as litNamespaceDirectivesAsyncReplace from "lit/directives/async-replace.js";
import * as litNamespaceDirectivesCache from "lit/directives/cache.js";
import * as litNamespaceDirectivesChoose from "lit/directives/choose.js";
import * as litNamespaceDirectivesClassMap from "lit/directives/class-map.js";
import * as litNamespaceDirectivesGuard from "lit/directives/guard.js";
import * as litNamespaceDirectivesIfDefined from "lit/directives/if-defined.js";
import * as litNamespaceDirectivesJoin from "lit/directives/join.js";
import * as litNamespaceDirectivesKeyed from "lit/directives/keyed.js";
import * as litNamespaceDirectivesLive from "lit/directives/live.js";
import * as litNamespaceDirectivesMap from "lit/directives/map.js";
import * as litNamespaceDirectivesRange from "lit/directives/range.js";
import * as litNamespaceDirectivesRef from "lit/directives/ref.js";
import * as litNamespaceDirectivesRepeat from "lit/directives/repeat.js";
import * as litNamespaceDirectivesStyleMap from "lit/directives/style-map.js";
import * as litNamespaceDirectivesTemplateContent from "lit/directives/template-content.js";
import * as litNamespaceDirectivesUnsafeHtml from "lit/directives/unsafe-html.js";
import * as litNamespaceDirectivesUnsafeMathml from "lit/directives/unsafe-mathml.js";
import * as litNamespaceDirectivesUnsafeSvg from "lit/directives/unsafe-svg.js";
import * as litNamespaceDirectivesUntil from "lit/directives/until.js";
import * as litNamespaceDirectivesWhen from "lit/directives/when.js";
import * as litNamespaceHtml from "lit/html.js";
import * as litNamespacePolyfillSupport from "lit/polyfill-support.js";
import * as litNamespaceStaticHtml from "lit/static-html.js";

const litNamespaces = {
  "lit": litNamespaceRoot,
  "lit/async-directive.js": litNamespaceAsyncDirective,
  "lit/decorators.js": litNamespaceDecorators,
  "lit/decorators/custom-element.js": litNamespaceDecoratorsCustomElement,
  "lit/decorators/event-options.js": litNamespaceDecoratorsEventOptions,
  "lit/decorators/property.js": litNamespaceDecoratorsProperty,
  "lit/decorators/query-all.js": litNamespaceDecoratorsQueryAll,
  "lit/decorators/query-assigned-elements.js": litNamespaceDecoratorsQueryAssignedElements,
  "lit/decorators/query-assigned-nodes.js": litNamespaceDecoratorsQueryAssignedNodes,
  "lit/decorators/query-async.js": litNamespaceDecoratorsQueryAsync,
  "lit/decorators/query.js": litNamespaceDecoratorsQuery,
  "lit/decorators/state.js": litNamespaceDecoratorsState,
  "lit/directive-helpers.js": litNamespaceDirectiveHelpers,
  "lit/directive.js": litNamespaceDirective,
  "lit/directives/async-append.js": litNamespaceDirectivesAsyncAppend,
  "lit/directives/async-replace.js": litNamespaceDirectivesAsyncReplace,
  "lit/directives/cache.js": litNamespaceDirectivesCache,
  "lit/directives/choose.js": litNamespaceDirectivesChoose,
  "lit/directives/class-map.js": litNamespaceDirectivesClassMap,
  "lit/directives/guard.js": litNamespaceDirectivesGuard,
  "lit/directives/if-defined.js": litNamespaceDirectivesIfDefined,
  "lit/directives/join.js": litNamespaceDirectivesJoin,
  "lit/directives/keyed.js": litNamespaceDirectivesKeyed,
  "lit/directives/live.js": litNamespaceDirectivesLive,
  "lit/directives/map.js": litNamespaceDirectivesMap,
  "lit/directives/range.js": litNamespaceDirectivesRange,
  "lit/directives/ref.js": litNamespaceDirectivesRef,
  "lit/directives/repeat.js": litNamespaceDirectivesRepeat,
  "lit/directives/style-map.js": litNamespaceDirectivesStyleMap,
  "lit/directives/template-content.js": litNamespaceDirectivesTemplateContent,
  "lit/directives/unsafe-html.js": litNamespaceDirectivesUnsafeHtml,
  "lit/directives/unsafe-mathml.js": litNamespaceDirectivesUnsafeMathml,
  "lit/directives/unsafe-svg.js": litNamespaceDirectivesUnsafeSvg,
  "lit/directives/until.js": litNamespaceDirectivesUntil,
  "lit/directives/when.js": litNamespaceDirectivesWhen,
  "lit/html.js": litNamespaceHtml,
  "lit/polyfill-support.js": litNamespacePolyfillSupport,
  "lit/static-html.js": litNamespaceStaticHtml,
};

Object.freeze(litNamespaces);

(() => {
  // Expose all lit entry points to support dynamic external usage in BAR bundles.
  Object.entries(litNamespaces).forEach(([namespace, litNamespace]) => {
    window[namespace] = litNamespace;
  });
})();

export const lit = litNamespaceRoot;
export { litNamespaces };
